<div class="container">
	<ul>
		<li>
			<label for="email">Enter your email:</label>
			<input type="email" id="email" name="email" (change)="emailAddressChange($event);">
		</li>
	</ul>
	<ul>
		<li>
			<a (click)="sendEmail()">Send Commercial Booking Confirmation Email</a>
		</li>
	</ul>
	<ul>
		<li>
			<a (click)="sendTTTConfirmationEmail()">Send TTT Confirmation Email</a>
		</li>
	</ul>
	<ul>
		<li>
			<a (click)="sendTTTExpirationWarningEmail()">Send TTT Expiration Warning Email</a>
		</li>
	</ul>
	<ul>
		<li>
			<a (click)="sendTTTExpiredEmail()">Send TTT Expired Email</a>
		</li>
		<li>
			<a (click)="sendAwardEmail()">Send Award Email</a>
		</li>
	</ul>
	<ul>
		<li>
			<a (click)="sendStopoverConfirmationEmail()">Send Stopover Confirmation Email</a>
		</li>
	</ul>
	<ul>
		<li>
			<a (click)="sendAddMoreEmail()">Send Add More To Your Trip Email</a>
		</li>
	</ul>
</div>
